import { $, $$ } from '../lib/domUtils';

const collapsed = $$('.c-collapsed');

collapsed.forEach(wrapper => {
  const content = $('.c-collapsed__content', wrapper);
  const control = $('.c-collapsed__control', wrapper);

  if (control) {
    control.addEventListener('click', () => {
      content.classList.remove('c-collapsed__content');
      control.parentNode.removeChild(control);
    });
  }
});
